import { useContextOrThrow } from '@deephaven/react-hooks';
import { PluginsContext } from "./PluginsContext.js";
export function usePlugins() {
  return useContextOrThrow(PluginsContext, 'No Plugins available in usePlugins. This can happen when plugins have not finished loading or if code is not wrapped in PluginsContext.Provider.');
}
export default usePlugins;
//# sourceMappingURL=usePlugins.js.map